// Fetch wrapper with a hard timeout so a stalled request (e.g. flaky mobile
// network inside the Android WebView) can never leave a page on an infinite
// spinner. Aborts after `timeoutMs` → the caller's catch/error path runs.
export const REQUEST_TIMEOUT_MS = 20000;

export default function fetchWithTimeout(url, options = {}, timeoutMs = REQUEST_TIMEOUT_MS) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  return fetch(url, { ...options, signal: controller.signal }).finally(() => clearTimeout(timer));
}
